import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { categoryApi } from "../service/categoryApi";
import { productApi } from "../service/productApi";
import { orderApi } from "../service/orderApi";
import { featuredApi } from "../service/featuredApi";
import { userApi } from "../service/userApi";
import { couponApi } from "../service/couponApi";
export const store = configureStore({
  reducer: {
    [categoryApi.reducerPath]: categoryApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [featuredApi.reducerPath]: featuredApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [couponApi.reducerPath]: couponApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(categoryApi.middleware)
      .concat(productApi.middleware)
      .concat(orderApi.middleware)
      .concat(featuredApi.middleware)
      .concat(userApi.middleware)
      .concat(couponApi.middleware),
});
setupListeners(store.dispatch);
